'use client';

import React, { HTMLAttributes, ReactNode } from 'react';

interface TextProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

/**
 * 共通テキスト
 * @param param0
 * @returns
 */
const Text: React.FC<TextProps> = ({ children, className, ...rest }) => {
  const defaultClassName = 'whitespace-pre-line break-all';

  // 渡されるテキストの前後の空白を削除
  const trimmedText = typeof children === 'string' ? children.trim() : children;

  return (
    <span className={`${defaultClassName} ${className || ''}`} {...rest}>
      {trimmedText}
    </span>
  );
};

export default Text;
